export const photos = [
    {
        src: "https://i.ibb.co/X73VKMF/admit.jpg",
        width: 4,
        height: 4
    },
    {
        src: "https://i.ibb.co/Bzm43Jy/2.jpg",
        width: 4,
        height: 4
    },
    {
        src: "https://i.ibb.co/w67Wnk1/3.jpg",
        width: 4,
        height: 4
    },
    {
        src: "https://i.ibb.co/kxsWHLc/4.jpg",
        width: 4,
        height: 4
    },
    {
        src: "https://i.ibb.co/P6ByPv7/5.jpg",
        width: 4,
        height: 4
    },
    {
        src: "https://i.ibb.co/tHdjP7L/6.jpg",
        width: 4,
        height: 3
    },
    {
        src: "https://i.ibb.co/7r5DY0M/1.jpg",
        width: 3,
        height: 4
    },
    {
        src: "https://i.ibb.co/wpgBL9K/certificate.jpg",
        width: 4,
        height: 3
    },
    {
        src: "https://i.ibb.co/4Vh2TKx/r8.jpg",
        width: 4,
        height: 4
    }
];
